import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resources from './resources'

export type Language = 'en' | 'fr'

function initI18n(defaultLanguage: string) {
  return i18n.use(initReactI18next).init({
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
    ns: ['common'],
    interpolation: {
      escapeValue: false,
    },
    resources,
    //   debug: environment.development,
  })
}

function getCurrentLanguage(): Language {
  return i18n.language.split('-')[0] as Language
}

function changeLanguage(language: Language) {
  return i18n.changeLanguage(language)
}

export { changeLanguage, getCurrentLanguage, initI18n }
